import { render, staticRenderFns } from "./jtjs.vue?vue&type=template&id=5792ccd4&scoped=true"
import script from "./jtjs.vue?vue&type=script&lang=js"
export * from "./jtjs.vue?vue&type=script&lang=js"
import style0 from "./jtjs.vue?vue&type=style&index=0&id=5792ccd4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5792ccd4",
  null
  
)

export default component.exports